import { z } from "zod";

import { containsXss } from "@/lib/utils/validation";

/**
 * Validates company names using Zod schema
 * - Requires at least 1 character
 * - Prevents HTML tags and special characters for security
 * - Used for validating company names in forms and API requests
 */
export const companyNameSchema = z
  .string()
  .min(1, "Company name is required")
  .refine((value) => !containsXss(value), {
    message: "Company name cannot contain HTML tags or special characters",
  });
